module.exports = __webpack_public_path__ + "static/media/img1.6501a2d7.jpg";